import React, { Component } from "react";  
//import Gallery from 'react-grid-gallery';
import { saveLikePartnerVideo, getLikePartnerVideo } from '../../API/FetchCall';
import Slider from 'react-slick';
import Lightbox from 'react-image-lightbox';
import { LikeVideo } from './../Banner/like_video';
import { Player } from 'video-react';

class CompVideos extends Component {  
  constructor(props) {  
    super(props);  
    this.state = {  
      name: "ReactJS",
      authe: false
    };  
    this.toggleModalopen.bind(this);
  }  

   componentDidMount() {

    let auth = localStorage.getItem("logged_auth");
    let data_auth = (localStorage.getItem("myData"));
    let userid, pid = '';
    if (data_auth) {
      let auth_data = JSON.parse(data_auth)
      this.setState({
        logged_name: auth_data.first_name + ' ' + auth_data.last_name,
        authe: true,
        user_id: auth_data.user_id,
      });
      userid = auth_data.user_id;
      pid = auth_data.isPartner;
    } else {
      userid = '';
    }

      let videoParm = this.props.videoParm;
      let video_path = this.props.video_path;
      let url = this.props.url;
      this.setState({videoParm:videoParm, video_path:video_path, url:url});
      this.GetDeta(userid);
   }

    GetDeta(user_id) {

        let reviewData = JSON.stringify({
            user_id: user_id,
            subcategory: this.props.videoParm.category,
            category: this.props.videoParm.main_category,
            page_id: this.props.videoParm.ref_id,
            vendor_id: this.props.videoParm.vendor_id,
            role: 4
        });
        console.log('this.props', this.props);
        getLikePartnerVideo(reviewData).then((response) => {
            let toastr = '';
            console.log('responseresponse', response)
            if (response.status == 1) {
                console.log(response)
                this.setState({
                    is_like_count: response.result.total_likes,
                    user_likes: response.result.is_like,
                })
            }
        });
    }


    likeFollow = (is_like) => {

        let reviewData = JSON.stringify({
            user_id: this.props.videoParm.user_id,
            subcategory: this.props.videoParm.category,
            category: this.props.videoParm.main_category,
            page_id: this.props.videoParm.ref_id,
            vendor_id: this.props.videoParm.vendor_id,
            is_like: is_like ? 1 : 0,
            role: 4
        });

        saveLikePartnerVideo(reviewData).then((response) => {
            let toastr = '';
            if (response.status == 1) {
                this.GetDeta(this.props.videoParm.user_id);
            } else {
            }
        });
    }

    isliked(is_like) {
        this.likeFollow(is_like);
    }

  toggleModalopen = (e) => {
    this.props.toggleModalopen();
  }

  render() {  


    const { videoParm, video_path, url } = this.state;
    
    return <div id="video_section"><h3>Videos</h3>
                     <div className='row n5v3k'>
                                <div className="container">
                                  {video_path!='' && 
                                  <Player
                                    playsInline
                                    src={url + video_path+"#t=0.1"}
                                  />
                                  }
                                  {video_path=='' && 
                                      <div><i>No video available</i></div>
                                  }
                                  <div>
                                    {(this.state.authe === false) ?
                                      <span onClick={this.toggleModalopen}>
                                          
                                    <div className="row">
                                          <div className="col-md-12 pt-3">
                                              <div className="text-small d-inline-flex mr-3">
                                                  <div class="form-group">
                                                      {(this.state.user_likes === 0) ?
                                                          <span title='Like this video' style={{ color: '#000' }}><i class="fa fa-thumbs-up" aria-hidden="true"></i> {this.state.is_like_count} Likes</span>
                                                          :
                                                          <span title='Like this video' style={{ color: '#000' }}><i class="fa fa-thumbs-up" style={{ color: 'grey' }} aria-hidden="true"></i> {this.state.is_like_count} Likes </span>
                                                      }
                                                  </div>
                                              </div>
                                              
                                          </div>
                                      </div>

                                      </span>
                                      :
                                <div className="row">
                                    <div className="col-md-12 pt-3">
                                        <div className="text-small d-inline-flex mr-3">
                                            <div class="form-group">
                                                {(this.state.user_likes === 0) ?
                                                    <span title='Like this video' style={{ color: '#000' }} onClick={() => this.isliked(true)}><i class="fa fa-thumbs-up" aria-hidden="true"></i> {this.state.is_like_count} Likes</span>
                                                    :
                                                    <span title='Like this video' style={{ color: '#000' }} onClick={() => this.isliked(false)} ><i class="fa fa-thumbs-up" style={{ color: 'grey' }} aria-hidden="true"></i> {this.state.is_like_count} Likes </span>
                                                }
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                    }
                                  </div>
                                </div>
                  </div>
          </div>
  }  
}  
   
export default CompVideos;